import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { TransactionHistoryStepUi } from "@src/widgets/onboarding/ui/tours/TransactionHistoryAndReports/steps/TransactionHistoryStepUi"

export class TransactionHistoryStep extends TourStepBase {
  component = TransactionHistoryStepUi
  name = `${ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS}_TransactionHistory`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_TRANSACTIONS_TABS .ant-tabs-nav-wrap"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate(paths.transactions)
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "One page to control every asset",
      title: "Transaction History",
    }
  }
}
